
import React, { useState } from 'react';
export default function SearchForm() {
  const [searchQuery, setSearchQuery] = useState('');

  const popularSearches = [
    'Furniture Assembly',
    'Deep Cleaning',
    'Help Moving',
    'TV Mounting',
    'Yard Work',
    'Delivery Service',
    'Home Organization',
    'Painting Help'
  ];

  return (
    <section>
      <div>
        <div>
          <div className="mt-8 max-w-2xl mx-auto">
            <div className="flex shadow-sm">
              <div className="relative flex-grow">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg 
                    className="h-5 w-5 text-gray-400" 
                    xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 0 20 20" 
                    fill="currentColor" 
                    aria-hidden="true"
                  >
                    <path 
                      fillRule="evenodd" 
                      d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" 
                      clipRule="evenodd" 
                    />
                  </svg>
                </div>
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 py-4 text-base border-gray-300 rounded-l-md"
                  placeholder="What need help with?"
                />
              </div>
              <button
                type="button"
                className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-r-md text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition duration-300"
              >
                Search
              </button>
            </div>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mt-10 flex flex-wrap justify-center gap-3">
            {popularSearches.map((search) => (
              <a
                key={search}
                href="#"
                className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 transition duration-300"
              >
                {search}
              </a>
            ))}
             <p className="mt-4 max-w-2xl mx-auto text-gray-500 text-center">
            What other people are looking for help with
          </p>
          </div>
        </div>
          </div>
        </div>
      </div>
    </section>
     );
}